import { render, staticRenderFns } from "./LabelAlias.vue?vue&type=template&id=142cd77d"
import script from "./LabelAlias.vue?vue&type=script&lang=ts"
export * from "./LabelAlias.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports